import {
  applySnapshot, flow, getEnv, types,
} from 'mobx-state-tree';
import { toast } from 'react-hot-toast';
import {
  ContactMessage,
  ContactMessageValues,
  ContactMessageListData,
  ListMetaDataModel,
} from '../types';
import { DEFAULT_META } from '../constants';

export const ContactMessageStoreModel = types.model('ContactMessageStore', {
  items: types.optional(types.array(types.frozen<ContactMessage>()), []),
  meta: types.optional(ListMetaDataModel, DEFAULT_META),
})
  .actions((self) => ({
    fetchContactMessages: flow(function* (params) {
      try {
        const res = yield getEnv(self).api.fetchContactMessages(params);
        const { items, meta } = res as ContactMessageListData;
        applySnapshot(self.items, items);
        self.meta = meta;
      } catch (e) {
        toast.error('Failed to fetch contact messages');
      }
    }),
    fetchContactMessageById: flow(function* (id: string) {
      try {
        const res = yield getEnv(self).api.fetchContactMessageById(id);
        applySnapshot(self.items, [res]);
      } catch (e) {
        toast.error('Failed to fetch contact message');
      }
    }),
    updateContactMessage: flow(function* (id: string, data: ContactMessageValues) {
      try {
        yield getEnv(self).api.updateContactMessage(id, data);
        toast.success('Contact message updated');
      } catch (e) {
        toast.error('Failed to update contact message');
      }
    }),
  }))
  .views((self) => ({
    // eslint-disable-next-line max-len
    getContactMessageById: (id: string): ContactMessage | undefined => self.items.find((item) => item.id === Number(id)),
  }));

// eslint-disable-next-line max-len
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/explicit-function-return-type
export const createContactUsStoreModel = () => types.optional(ContactMessageStoreModel, {});
